export default __webpack_public_path__ + "static/media/330_dummy2016-fotograf04-de.3372cb04.png";